var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"outlined":"","pill":""}},on),[_vm._v(_vm._s(_vm.gigabytes))])]}}])},[_vm._v(" "+_vm._s(_vm.bytes)+" bytes ")]),_c('v-layout',{attrs:{"justify-end":""}},[_c('div',{staticClass:"size-bar",style:(_vm.dynamicStyle)})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }